import React, {Fragment, memo} from 'react';
import {Table} from "react-bootstrap";

import Loader from '../Loader';

const AggregatedReport = ({data, reference, isLoading}) => {
    if (!reference.payment_types || !reference.services || !data.tickets_service_report || !data.tickets_payment_type_report) {
        return null;
    }

    const servicesReport = data.tickets_service_report;
    const paymentTypesReport = data.tickets_payment_type_report;
    const cashiersReport = data.tickets_cashiers_report;
    const cashDesksCashReport = data.tickets_cash_desks_cash_report;
    const cashDesksCashQuantityReport = data.tickets_cash_desks_quantity_report;

    const paymentTypes = reference.payment_types;
    const services = reference.services;
    const cashiers = reference.cashiers;
    const cashDesks = reference.cash_desks;

    if (isLoading) {
        return <Loader />;
    }
    return (
        <div
            style={{marginTop: '16px'}}
            className='reports'
        >
            <h5>Сума коштів отримана за реалізовані квитки</h5>
            <Table
                striped
                bordered
                hover
                size="sm"
                style={{marginTop: '16px'}}
                className='payment-types-report'
            >
                <thead>
                <tr>
                    <th/>
                    {paymentTypes.map(pt => <th key={pt.id}>{pt.name}</th>)}
                    <th>Всього</th>
                </tr>
                </thead>
                <tbody>
                {Object.keys(paymentTypesReport).map(date => (
                    <tr key={date}>
                        <td>{date}</td>
                        {paymentTypes.map(pt => <td key={pt.id}>{paymentTypesReport[date][pt.id]}</td>)}
                        <td><b>{paymentTypesReport[date]['total']}</b></td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <hr/>

            <h5>Кількість реалізованих квитків</h5>
            <Table
                striped
                bordered
                hover
                size="sm"
                style={{marginTop: '16px'}}
                className='services-report'
            >
                <thead>
                <tr>
                    <th/>
                    {services.map(s => <th key={s.id}>{s.name.replace(' - ДіноСофія', '')}</th>)}
                    <th>Всього</th>
                </tr>
                </thead>
                <tbody>
                {Object.keys(servicesReport).map(date => (
                    <tr key={date}>
                        <td>{date}</td>
                        {services.map(s => <td key={s.id}>{servicesReport[date][s.id]}</td>)}
                        <td><b>{servicesReport[date]['total']}</b></td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <hr/>

            <h5>Кількість реалізованих квитків по касах</h5>
            <Table
                striped
                bordered
                hover
                size="sm"
                style={{marginTop: '16px'}}
                className='services-report'
            >
                <thead>
                <tr>
                    <th/>
                    {Object.keys(cashDesksCashQuantityReport).map(date => (
                        <td key={date}>{date}</td>
                    ))}
                </tr>
                </thead>
                <tbody>
                {cashDesks.map(c => (
                    <tr key={c.id}>
                        <td>{c.name}</td>
                        {Object.keys(cashDesksCashQuantityReport).map(date => (
                            <td key={date}>{cashDesksCashQuantityReport[date][c.id]}</td>
                        ))}
                    </tr>
                ))}
                <tr />
                </tbody>
            </Table>
            <hr/>

            <h5>Готівка касирів</h5>
            <Table
                striped
                bordered
                hover
                size="sm"
                style={{marginTop: '16px'}}
                className='services-report'
            >
                <thead>
                <tr>
                    <th/>
                    {Object.keys(cashDesksCashReport).map(date => (
                        <td key={date} colSpan={2}>{date}</td>
                    ))}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td/>
                    {Object.keys(cashDesksCashReport).map(date => (
                        <Fragment key={date}>
                            <td>Готівка</td>
                            <td>Безготівка</td>
                        </Fragment>
                    ))}
                </tr>
                {cashDesks.map(c => (
                    <tr key={c.id}>
                        <td>{c.name}</td>
                        {Object.keys(cashDesksCashReport).map(date => (
                            <Fragment key={date}>
                                <td>{cashDesksCashReport[date][c.id][1]}</td>
                                <td>{cashDesksCashReport[date][c.id][4]}</td>
                            </Fragment>
                        ))}
                    </tr>
                ))}
                <tr />
                </tbody>
            </Table>
            <hr/>

            <h5>Кількість реалізованих квитків касирами Софіївки</h5>
            <Table
                striped
                bordered
                hover
                size="sm"
                style={{marginTop: '16px'}}
                className='services-report'
            >
                <thead>
                <tr>
                    <th/>
                    {Object.keys(cashiersReport).map(date => (
                        <td key={date}>{date}</td>
                    ))}
                </tr>
                </thead>
                <tbody>
                {cashiers.map(c => (
                    <tr key={c.id}>
                        <td>{c.name}</td>
                        {Object.keys(cashiersReport).map(date => (
                            <td key={date}>{cashiersReport[date][c.id]}</td>
                        ))}
                    </tr>
                ))}
                <tr />
                </tbody>
            </Table>
            <hr/>
        </div>
    )
};

export default memo(AggregatedReport, (prevProps, nextProps) => prevProps.data === nextProps.data);
